import React, { useMemo } from 'react';
import MapCanvas from '../../MapCanvas';
import { createDefaultMapData, countSeats, countOccupied } from '../../seatingMapUtils';

/**
 * Schematic template — black-and-white view with seat numbers instead of names.
 */
const Schematic = ({ mapData, title = 'מפת מושבים', showTitle = true }) => {
  const data = mapData || createDefaultMapData();
  const total = countSeats(data);
  const occupied = countOccupied(data);

  // Override colors to B&W
  const bwData = useMemo(() => ({
    ...data,
    colors: {
      occupied: '#333',
      empty: '#d4d4d4',
      landmark: '#555',
    },
  }), [data]);

  return (
    <div className="seating-map-wrapper seating-map-schematic">
      {showTitle && (
        <div className="seating-map-header">
          <span className="seating-map-title">{title}</span>
        </div>
      )}

      <div className="seating-map-body">
        <MapCanvas mapData={bwData} showNames />
      </div>

      <div className="seating-map-legend">
        <span>סה"כ: {total} מושבים | תפוסים: {occupied} | פנויים: {total - occupied}</span>
      </div>
    </div>
  );
};

export default Schematic;
